<script lang="ts">
	import Card from '$lib/components/Card.svelte';

	let { data } = $props();
</script>

<div class="container mx-auto mb-28 w-full max-w-full py-4 sm:mb-20 sm:max-w-3xl md:max-w-7xl">
	<h1 class="mb-4 text-2xl font-bold">Posts tagged with "{data.slug}"</h1>
	{#if data.posts.length > 0}
		<ul class="flex flex-col gap-4">
			{#each data.posts as post}
				<li>
					<Card>
						<h2>
							<a
								href={`/blog/${post.slug}`}
								class="text-gray-800 no-underline hover:text-gray-700 hover:underline dark:text-gray-100 dark:hover:text-gray-50"
								>{post.title}</a
							>
						</h2>
						<time class="text-sm tracking-tighter">{new Date(post.date).toLocaleDateString()}</time>
						<p class="mb-2">{post.description}</p>
						{#if post.tags}
							<ul class="flex flex-wrap gap-2">
								{#each post.tags as tag}
									<li>
										<a
											href="/blog/tags/{tag}"
											class="rounded border-[1px] border-gray-400 bg-gray-300 px-2 py-1 text-xs text-gray-800 no-underline hover:bg-gray-200 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 hover:dark:bg-gray-700 dark:hover:text-gray-100"
										>
											{tag}
										</a>
									</li>
								{/each}
							</ul>
						{/if}
					</Card>
				</li>
			{/each}
		</ul>
	{:else}
		<p class="text-gray-500">No posts found for this tag.</p>
	{/if}
</div>
